import { render } from "./UserAccountEmailSettingsInfo.vue?vue&type=template&id=78fd508f"
import script from "./UserAccountEmailSettingsInfo.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./UserAccountEmailSettingsInfo.vue?vue&type=script&charset=utf-8&lang=js"

import "./UserAccountEmailSettingsInfo.vue?vue&type=style&index=0&id=78fd508f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__